/**
 * Configuración que llega por variables de entorno de Vite (`VITE_*`).
 * Centralizarla evita leer `import.meta.env` desde componentes.
 */

/** Prefijo por defecto del API cuando corre detrás del proxy de Vite o en el mismo dominio. */
const DEFAULT_API_URL = '/api'

/** URL base del API (incluye `/api`), p. ej. `https://api.tumin.gt/api`. */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL || DEFAULT_API_URL

/** Llave pública de Cloudflare Turnstile; si no existe, el login no muestra captcha. */
export const TURNSTILE_SITE_KEY: string | undefined = import.meta.env.VITE_TURNSTILE_SITE_KEY || undefined

/**
 * DSN de Sentry (o servicio compatible) para reportar errores del navegador.
 * Sin él no se reporta nada. Su origen debe estar en `connect-src` de la CSP
 * (lo agrega el build al generar `_headers`).
 */
export const SENTRY_DSN: string | undefined = import.meta.env.VITE_SENTRY_DSN || undefined

/** Versión desplegada que acompaña a cada evento de error (p. ej. el commit). */
export const SENTRY_RELEASE: string | undefined = import.meta.env.VITE_SENTRY_RELEASE || undefined

/** Ambiente de los eventos de error: `VITE_APP_ENV` o el modo de Vite (`production`, `development`). */
export const APP_ENVIRONMENT: string = import.meta.env.VITE_APP_ENV || import.meta.env.MODE

/** Nombre de respaldo mientras llega el branding de la institución. */
export const FALLBACK_APP_NAME: string = import.meta.env.VITE_APP_NAME || 'Tumin'
